import React from 'react'
import { Route } from 'react-router-dom'
import Contracts from '../Views/Web/Client Management/Clients/Contracts'
import Inspection from '../Views/Web/Client Management/Clients/Inspection'
import Equipments from '../Views/Web/Client Management/Clients/Equipments'
import Service from '../Views/Web/Client Management/Clients/Service'
import Invoice from '../Views/Web/Client Management/Clients/invoice'
import { IndexQuotes, QuotesCreate, QuotesEdit, QuotesMain, QuotesView } from '../Views/Web/Client Management/Quotes/Index'
import MainQuotesman from '../Views/Web/Client Management/MainQuotesman'

function QuotationRoutes() {
    return (
      <Route path="quotation" element={<MainQuotesman />}>
          <Route path="quote" element={<QuotesMain/>} >
           <Route index element={<IndexQuotes/>} />
           <Route path='create' element={<QuotesCreate/>} />
           <Route path='edit/:quotesEditId' element={<QuotesEdit/>} />
           <Route path='view/:quotesViewId' element={<QuotesView/>} />
           {/* <Route path='contracts/:clientViewId' element={<Contracts/>} />
           <Route path='inspection/:clientViewId' element={<Inspection/>} />
           <Route path='equipments/:clientViewId' element={<Equipments/>} />
           <Route path='service/:clientViewId' element={<Service/>} />
           <Route path='invoice/:clientViewId' element={<Invoice/>} /> */}
          </Route>
         {/* <Route path="survey-report" element={<SurveyReportMain/>} >
           <Route index element={<IndexSurveyReport/>} />
           <Route path='create' element={<SurveyReportCreate/>} />
           <Route path='edit/:surveyReportEditId' element={<SurveyReportEdit/>} />
           <Route path='view/:surveyReportViewId' element={<SurveyReportsView/>} />
           <Route path='form/:surveyReportViewId' element={<ViewForm/>} />

          </Route>
         
          <Route path="contracts" element={<ContractsMain/>} >
           <Route index element={<IndexContract/>} />
           <Route path='create' element={<ContractsCreate/>} />
           <Route path='edit/:contractsEditId' element={<ContractsEdit/>} />
           <Route path='view/:contractsViewId' element={<ContractsView/>} />
           <Route path='form/:contractsViewId' element={<FormContract/>} />
           <Route path='equipments/:contractsViewId' element={<EquipmentsContract/>} />
           <Route path='inspection/:contractsViewId' element={<InspectionContract/>} />
           <Route path='invoice/:contractsViewId' element={<InvoiceContract/>} />
           <Route path='service/:contractsViewId' element={<ServiceContract/>} />



          </Route> */}
          
      </Route>
    )
  }
  
  export default QuotationRoutes